import { gql } from '@apollo/client';

export const AscProjectTeamMemberFragment = gql`
  fragment AscProjectTeamMember on AscProjectTeamMember {
    contributorId
    contributorName
    contributorEmail
    allocationPercent
    periodName
    ascProjectId
    fiscalYearId
  }
`;
